import { observable, action, computed } from "mobx";

import { getCurrentCulture } from "@utils";
import { LoaderStore } from "@state/stores/common";
import { Bet } from "@models";
import ModalService from "@services/modals/ModalService";
import { redirect } from "@state";
import { RootStore } from "@state/stores/types.js";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

type ModalData = {
	id?: string;
	betSlipNumber?: string;
	isLive?: boolean;
	userId?: string;
};

export class ReuseBetSlipStore {
	rootStore: RootStore;

	loader: LoaderStore;
	bet: Bet | null = null;
	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	//#region observables

	@observable isReuseModalOpen = false;
	@observable reuseModalData: ModalData | null;

	//#endregion observables

	@computed get isLoadingProcess(): boolean {
		return this.loader.isLoadingProcess;
	}

	//#region modals

	@action.bound
	reuseBetSlip() {
		this.rootStore.betSlipStore.useBetSlip(this.bet);

		if (this.bet?.isLive) {
			redirect(`/${getCurrentCulture()}/${DefaultPath.LIVE}/`);
		} else {
			redirect(`/${getCurrentCulture()}/${DefaultPath.PREMATCH}`);
		}

		this.closeReuseBetSlipModal();
		this.closeReuseBetSlipModalBetDetails();
	}

	/**
	 * Opens reuse bet slip modal
	 * @param {{id, betSlipNumber}} modalData
	 */
	@action.bound
	openReuseBetSlipModal(bet: Bet) {
		this.isReuseModalOpen = true;
		this.reuseModalData = {
			betSlipNumber: bet.betSlipNumber,
			id: bet.id,
			isLive: bet.isLive,
			userId: bet.userId ? bet.userId : "",
		};
		this.bet = bet;
		ModalService.onOpen();
	}

	@action.bound
	openReuseBetSlipModalBetDetails(bet: Bet) {
		this.reuseModalData = {
			betSlipNumber: bet.betSlipNumber,
			id: bet.id,
			isLive: bet.isLive,
			userId: bet.userId ? bet.userId : "",
		};
		this.bet = bet;
	}

	@action.bound
	closeReuseBetSlipModalBetDetails() {
		this.isReuseModalOpen = false;
		this.reuseModalData = null;
		this.bet = null;
	}
	/**
	 * Closes reuse bet slip modal
	 */
	@action.bound
	closeReuseBetSlipModal() {
		this.isReuseModalOpen = false;
		this.reuseModalData = null;
		this.bet = null;
	}

	//#endregion modals

	//#region disposers

	@action.bound
	onDispose() {
		this.isReuseModalOpen = false;
		this.reuseModalData = null;
		this.bet = null;
	}

	//#endregion disposers
}
